import { z } from 'zod'

const clarificationQuestionSchema = z.object({
  id: z.string(),
  question: z.string(),
  required: z.boolean().optional().default(true),
  input: z.object({ type: z.enum(['text', 'email', 'number', 'date', 'select']) }),
  options: z.array(z.object({ value: z.string(), label: z.string() })).default([]),
  allow_other: z.boolean().optional().default(true),
})

// Questions the turn could not answer for itself. `assistant_message_id` and a
// non-empty `questions` are what discriminate it — `status` cannot, because
// `.catch()` means it never fails to parse. It is checked last in
// `toTypedBlock` for the reason stated there.
export const clarificationCardSchema = z.object({
  assistant_message_id: z.string(),
  version: z.number().optional(),
  status: z.enum(['open', 'submitted']).catch('open'),
  source: z.enum(['agent', 'composio_validation']).optional(),
  questions: z.array(clarificationQuestionSchema).min(1).max(5),
  submitted_answers: z.record(z.string()).optional(),
})
